var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { "data-cy": "register-step-form" } },
    [
      _c("div", { staticClass: "Vlt-card__image Vlt-bg-black" }, [
        _c(
          "div",
          { staticClass: "Vlt-grid Vlt-white" },
          _vm._l(_vm.steps, function (step) {
            return _c(
              "div",
              {
                key: step.key,
                class: {
                  "Vlt-col Vlt-left step": true,
                  "step--active": step.key === _vm.currentStep,
                },
              },
              [
                _vm.isStepComplete(step.key) && !step.error
                  ? _c(
                      "span",
                      [
                        _c("vlt-icon", {
                          staticClass: "Vlt-green",
                          attrs: {
                            icon: "check-circle-negative",
                            small: "",
                            color: "green",
                          },
                        }),
                      ],
                      1
                    )
                  : step.error
                  ? _c(
                      "span",
                      [
                        _c("vlt-icon", {
                          staticClass: "Vlt-green",
                          attrs: {
                            icon: "cross-circle",
                            small: "",
                            color: "red",
                          },
                        }),
                      ],
                      1
                    )
                  : _c("span", {
                      staticClass: "Vlt-number step-number",
                      attrs: { "data-index": step.key },
                    }),
                _c("span", { staticClass: "step-label" }, [
                  _vm._v(_vm._s(step.label)),
                ]),
              ]
            )
          }),
          0
        ),
        _c("div", { staticClass: "Vlt-progress" }, [
          _c("div", {
            staticClass: "Vlt-progress__bar",
            style: { width: `${_vm.progressWith}%` },
            attrs: {
              "data-cy": "progress-bar",
              role: "progressbar",
              "aria-valuenow": "0",
              "aria-valuemin": "0",
              "aria-valuetext": "Step 1: example",
              "aria-valuemax": "100",
            },
          }),
        ]),
      ]),
      !_vm.readOnly
        ? _c("vwc-banner", {
            attrs: {
              connotation: "warning",
              open: "",
              message: "Exiting the form will delete all changes made",
            },
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "progress-content" },
        [
          _vm.isUpdatesRequired
            ? _c(
                "div",
                {
                  class: [
                    "updates-required-banner",
                    _vm.updatesRequired.connotation,
                  ],
                },
                [
                  _c(
                    "div",
                    { staticClass: "left-side-container" },
                    [
                      _c("vwc-icon", {
                        staticClass: "icon-updates-required",
                        attrs: { type: _vm.updatesRequired.icon },
                      }),
                      _c("p", [_vm._v(_vm._s(_vm.updatesRequired.text))]),
                    ],
                    1
                  ),
                  _c("cd-button", {
                    staticClass: "updates-required-button",
                    attrs: {
                      connotation: "primary",
                      layout: _vm.getLayout,
                      label: "View Required Changes",
                      icon: _vm.getIcon,
                    },
                    on: { click: _vm.toggleButton },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._t(_vm.currentStepSlot),
          _c(
            "div",
            { staticClass: "footer-buttons" },
            [
              _vm._t("footer-buttons"),
              _vm.cancelButton
                ? _c("cd-button", {
                    staticClass: "cancel-button",
                    attrs: {
                      "data-cy": "cancel-button",
                      layout: "outlined",
                      connotation: "primary",
                      label: _vm.$t("common.cancelBtnLabel"),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("cancel")
                      },
                    },
                  })
                : _vm._e(),
              _vm.currentStep > 1
                ? _c("cd-button", {
                    staticClass: "back-button",
                    attrs: {
                      layout: "outlined",
                      "data-cy": "back-button",
                      connotation: "primary",
                      label: _vm.$t("common.backButtonLabel"),
                    },
                    on: { click: _vm.back },
                  })
                : _vm._e(),
              _vm.nextStepShown
                ? _c(
                    "cd-button",
                    {
                      attrs: {
                        layout: "filled",
                        "data-cy": "next-button",
                        connotation:
                          _vm.nextStepLabel ===
                          this.$t("smsRegistrations.submitAndPay")
                            ? "cta"
                            : "primary",
                        label: _vm.nextStepLabel,
                        disabled:
                          _vm.nextStepDisabled || _vm.registerInProgress,
                      },
                      on: { click: _vm.nextStep },
                    },
                    [
                      _vm.registerInProgress
                        ? _c("cd-spinner", {
                            staticClass: "inner-spinner",
                            attrs: {
                              slot: "trailingIcon",
                              indeterminate: "",
                              density: -7.5,
                            },
                            slot: "trailingIcon",
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        2
      ),
      _c("vwc-snackbar", {
        ref: "errSnackbar",
        attrs: {
          connotation: "alert",
          icon: "megaphone-solid",
          message: this.$t("smsRegistrations.submitAndPayError"),
          timeoutMs: 10000,
          "data-cy": "reg-error-snack",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }